import React from 'react';
import Slider from 'react-slick';
import styles from './styles.module.scss';

import LinkWrap from '../../Wraps/LinkWrap';
import ImagePlaceholder from '../../Placeholder';

import Config, { spanish } from '../../../config/config';

import placeholderMobile from '../../../assets/placeholder/hero-mobile.jpg';
import placeholderDesktop from '../../../assets/placeholder/hero-desktop.jpg';

const Slide = ({ item }) => {
  const { category, product } = item;
  let linkTo = item?.LinkTo;
  let historyState = {};
  if (category !== null && product === null) {
    linkTo = `/category/${category?.SLUG}`;
    historyState = { categoryId: category?.categoryID };
  } else if (category === null && product !== null) {
    linkTo = `/product/${product?.SLUG}`;
    historyState = { sku: product?.SKU };
  }
  const isExternal = linkTo !== null && product === null && category === null;
  return (
    <LinkWrap
      to={linkTo}
      className={styles.item}
      state={historyState}
      isExternal={isExternal}
    >
      {item?.ImageMobile.url && item?.ImageDesktop.url && item?.SEO ? (
        <picture>
          <source
            srcSet={`${Config.cdn.cdn_path}${
              spanish ? item?.ImageDesktop?.url : item?.imageDesktopEnglish?.url
            }`}
            media="(min-width: 1025px)"
          />
          <img
            src={`${Config.cdn.cdn_path}${
              spanish ? item?.ImageMobile?.url : item?.imageMobileEnglish?.url
            }`}
            alt={item?.SEO}
          />
        </picture>
      ) : (
        <ImagePlaceholder
          mobile={placeholderMobile}
          desktop={placeholderDesktop}
        />
      )}
    </LinkWrap>
  );
};

const SliderBanner = ({ data }) => {
  const settings = {
    autoplay: true,
    infinite: true,
    dots: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div className={styles.container}>
      <Slider {...settings}>
        {data
          ?.sort((a, b) => a.order - b.order)
          .map((item, key) => (
            <Slide item={item} key={key} />
          ))}
      </Slider>
    </div>
  );
};

export default SliderBanner;
